import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import {
  RecoverPasswordRequest,
  RecoverPasswordSetNewForm,
} from '@/common/my-account';
import {
  RecoverPasswordEmailSentMessage,
  RecoverPasswordError,
  RecoverPasswordForm,
  RecoverPasswordNewForm,
  RecoverPasswordNewPasswordSetMessage,
} from '@/sleeper/components';
import {
  useIsTelesales,
  useRecoverPassword,
  useRecoverPasswordSetNew,
} from '@/sleeper/hooks';

export const PasswordRecoveryPage = () => {
  const { query } = useRouter();
  const { token } = query;
  const isTelesales = useIsTelesales();
  const [wasRecoveryEmailSent, setWasRecoveryEmailSent] = useState(false);
  const [wasPasswordSet, setWasPasswordSet] = useState(false);
  const {
    error: errorRecoverPassword,
    isLoading: isLoadingRecoverPassword,
    recoverPassword,
  } = useRecoverPassword();
  const {
    error: errorNewPassword,
    isLoading: isLoadingNewPassword,
    setNewPassword,
  } = useRecoverPasswordSetNew();
  const error = errorRecoverPassword || errorNewPassword;
  const hasToken = token && typeof token === 'string';
  const handleSendRecoverySubmit = useCallback(
    async (data: RecoverPasswordRequest) => {
      const err = await recoverPassword(data);

      setWasRecoveryEmailSent(!err);
    },
    [recoverPassword],
  );
  const handleNewPasswordSubmit = useCallback(
    async (data: RecoverPasswordSetNewForm) => {
      if (!hasToken) {
        return;
      }

      const err = await setNewPassword({
        ...data,
        token,
      });

      setWasPasswordSet(!err);
    },
    [hasToken, setNewPassword, token],
  );

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          {isTelesales ? (
            <div className="logo logo--vertical">
              <span className="sr-only">Caledonian Sleeper</span>
            </div>
          ) : (
            <a href={'/'} className="logo logo--vertical">
              <span className="sr-only">Caledonian Sleeper</span>
            </a>
          )}

          <div className="box">
            {error && <RecoverPasswordError error={error} />}
            {hasToken && !wasPasswordSet && (
              <RecoverPasswordNewForm
                onSubmit={handleNewPasswordSubmit}
                isDisabled={isLoadingNewPassword}
                token={token}
              />
            )}
            {hasToken && wasPasswordSet && (
              <RecoverPasswordNewPasswordSetMessage />
            )}
            {!hasToken && !wasRecoveryEmailSent && (
              <RecoverPasswordForm
                onSubmit={handleSendRecoverySubmit}
                isDisabled={isLoadingRecoverPassword}
              />
            )}
            {!hasToken && wasRecoveryEmailSent && (
              <RecoverPasswordEmailSentMessage />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordRecoveryPage;
